import { gql } from '@apollo/client';

import { subscriptionPartial } from '../partials';
import { cartPartial } from '../partials/cart/Cart';

export const getCart = gql`
  query getCart {
    ${cartPartial(subscriptionPartial)}
  }
`;
